export default __webpack_public_path__ + "locales/ja-JP/ResetApplicationDialog.json?hash=5b197ab85353d4c5b65ca77669754d9d";